import { DreamBlock } from '@typedream/core';
import {
  blurEditor,
  deleteBackward,
  getEndPoint,
  select,
  withoutNormalizing,
} from '@udecode/plate-core';
import { setBlockType } from '../../editorTools/transforms';
import { getTElementPlugin } from '../../plate';
import { DreamEditor } from '../../types';
import { getSelectedElementEntry } from '../elementSelection';

export const selectOption = (editor: DreamEditor, type: DreamBlock['type']) => {
  const plugin = getTElementPlugin(editor, type);
  const format = plugin.options?.format;

  withoutNormalizing(editor, () => {
    const selectedElementEntry = getSelectedElementEntry(editor);

    if (!selectedElementEntry) return;

    deleteBackward(editor, { unit: 'block' });

    setBlockType(editor, type, { at: selectedElementEntry[1] });
    // TODO: Add Slash Command to show the initial ui of collection

    if (format?.blurAfterSet) {
      blurEditor(editor);
    } else {
      select(editor, getEndPoint(editor, selectedElementEntry[1]));
    }

    if (format?.onInsert) format.onInsert(editor, selectedElementEntry[1]);
  });
};
